var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellNarrowinline = function SvgBellNarrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 18.823c-.919 0-1.667-.886-1.667-1.975V9.344c0-4.792-3.289-8.69-7.333-8.69s-7.333 3.898-7.333 8.69v7.504c0 1.089-.748 1.975-1.667 1.975-.552 0-1 .53-1 1.185 0 .654.448 1.185 1 1.185h18c.552 0 1-.531 1-1.185s-.448-1.185-1-1.185M12.264 22.334H8.735a.7.7 0 0 0-.57.316.96.96 0 0 0-.15.716c.255 1.407 1.277 2.39 2.485 2.39s2.23-.983 2.484-2.39a.96.96 0 0 0-.148-.716.7.7 0 0 0-.571-.316z"
  })));
};
export default SvgBellNarrowinline;